jQuery(document).ready(function($){
    $('.gform_wrapper .gform_body .gform_fields .gfield .ginput_container_fileupload .gform_drop_instructions').each(function() {
        console.log($(this).siblings());
        if($(this).siblings().length){
            $(this).add($(this).siblings()).wrapAll('<div class="wrapper-div"></div>');
            $(this).text('Drag and drop file or');
            $(this).siblings().html('BROWSE');
            let span = document.createElement('div');
            span.classList.add('gform_drop_instructions');
            span.innerHTML = "File type: pdf, doc, docx";
            $(this).parent().append(span);
        }
    });
});